import React from 'react';
import './KofiWidget.scss';

const KofiWidget: React.FC = () => {
    return (
        <iframe
            id="kofiframe"
            className="kofi-widget"
            src="https://ko-fi.com/aisummer/?hidefeed=true&widget=true&embed=true&preview=true"
            title="aisummer"
        ></iframe>
        
    );
};

export default KofiWidget;
